//  @flow

import React from 'react';
import { renderRoutes } from 'react-router-config';
import { Switch } from 'react-router-dom';
import { ThemeProvider } from 'emotion-theming';

import { NavigationContextProvider } from './shared/components/NavigationContext';
import routes from './routes';
import theme from './theme';

export default function App() {
  return (
    // Universal React provider components are defined here.
    // Client-side provider components are in src/_client/entry.js
    // Server-side provider components are in src/_server/entry.js
    <ThemeProvider theme={theme}>
      <NavigationContextProvider>
        <Switch>{renderRoutes(routes)}</Switch>
      </NavigationContextProvider>
    </ThemeProvider>
  );
}
